var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalog__list"},_vm._l((_vm.products),function(product){return _c('ProductItem',{key:product.id,attrs:{"product":product}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }